﻿{
  "version": 1,
  "gameId": "battleship",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0, "hintCoins": 10 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "battleship.rules.navigationLabel",
    "kickerKey": "battleship.rules.kicker",
    "titleKey": "battleship.rules.title",
    "summaryKey": "battleship.rules.summary",
    "sections": [
      { "id": "fleet", "key": "battleship.rules.fleet" },
      { "id": "placement", "key": "battleship.rules.placement" },
      { "id": "salvo", "key": "battleship.rules.salvo" },
      { "id": "results", "key": "battleship.rules.results" },
      { "id": "hint", "key": "battleship.rules.hint" },
      { "id": "victory", "key": "battleship.rules.victory" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {}
}
